{
  "title": "docente",
  "imgFondoPizarra": ""
}